<div class="h-screen flex flex-col overflow-hidden bg-gray-50">
  <!-- The clinic's plan is in grace, expired or cancelled. -->
  <app-plan-banner></app-plan-banner>

  <!-- Top Header -->
  <app-dashboard-header></app-dashboard-header>

  <div class="flex-1 flex overflow-hidden">
    <!-- Sidebar below header -->
    <app-sidebar></app-sidebar>

    <!-- Main content area -->
    <main class="flex-1 overflow-y-auto relative">
      <router-outlet></router-outlet>

      <!-- Global Diagnocat Tracker -->
      <app-diagnocat-floating-status></app-diagnocat-floating-status>
      <app-dio-floating-status></app-dio-floating-status>
    </main>
  </div>
</div>